export default {
    billboard: 'หน้าประกาศรวม',
    createMessage: 'สร้างประกาศ',
    startDate: 'วันที่เริ่ม',
    endDate: 'วันที่สิ้นสุด',
    topic: 'หัวข้อ',
    searchByTopic: 'ค้นหาด้วยหัวข้อ',
    search: 'ค้นหา',
    deleteMessage: 'ลบประกาศ',
    congratulation: 'ยินดีด้วย',
    msgDeleteSuccess: 'ประกาศถูกลบเเล้ว',
    questionDelete: 'คุณเเน่ใจว่าต้องการที่จะลบประกาศ "$Name" ?'
}
